import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { getAssetUrl } from '@utils/common.utils';
import { useEffect, useRef } from 'react';
import { CTASource } from '@components/banner/types';
import { BrowserType } from '@constants/common';
import {
  EXIT_INTENT_MODAL_BG_IMG_PATH,
  EXIT_INTENT_MODAL_BG_IMG_WEBP_PATH,
} from '@constants/assets-path';

interface ExitIntentModalPropTypes {
  closeExitIntentModal: Function;
  buttonAction: Function;
  browser: BrowserType;
}
const ExitIntentModal = ({
  closeExitIntentModal,
  buttonAction,
  browser,
}: ExitIntentModalPropTypes) => {
  const timerRef = useRef<number>();

  const handleCloseModal = () => {
    closeExitIntentModal();
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
  };

  const handleClick = () => {
    handleCloseModal();
    buttonAction(CTASource.EXIT_INTENT_MODAL);
  };

  useEffect(() => {
    timerRef.current = window.setTimeout(() => {
      handleCloseModal();
    }, 60 * 1000);

    return () => {
      window.clearTimeout(timerRef.current);
    };
  }, []);

  const bgImagePath =
    browser !== BrowserType.Safari
      ? EXIT_INTENT_MODAL_BG_IMG_WEBP_PATH
      : EXIT_INTENT_MODAL_BG_IMG_PATH;

  return (
    <div
      className={ivclass(
        'iv-fixed',
        'iv-top-0 iv-left-0 iv-z-[9999]',
        'iv-bg-black-35',
        'iv-h-full iv-w-full',
        'iv-overflow-x-hidden',
      )}
      id="exitIntentModal"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exitIntentModal"
      aria-hidden="true"
    >
      <div
        className={ivclass(
          'iv-flex',
          'iv-items-center',
          'iv-min-h-full iv-min-w-full',
        )}
      >
        <div
          className={ivclass(
            'iv-relative',
            'iv-flex',
            'iv-flex-col iv-items-center iv-justify-center',
            'iv-w-full iv-h-full',
            'sm:iv-p-15 md:iv-p-20 lg:iv-p-20 xl:iv-p-20',
          )}
        >
          <div
            className={ivclass(
              'iv-sticky-card-bg',
              'iv-relative',
              'iv-max-w-[697px]',
              'iv-w-full',
              'iv-h-[500px] sm:iv-h-[360px]',
              'iv-rounded-[20px]',
              'iv-pt-[23px] iv-px-[33px] iv-pb-30',
              'iv-bg-grey-0',
              'iv-shadow-xl',
            )}
          >
            <div
              className={ivclass(
                'iv-absolute',
                'iv-z-10',
                'iv-top-[30px] sm:iv-top-[15px] md:iv-top-[15px]',
                'iv-right-[30px] sm:iv-right-[15px] md:iv-right-[15px]',
                'iv-top-[-11px] iv-right-[-11px]',
              )}
            >
              <button
                onClick={handleCloseModal}
                className={ivclass(
                  'iv-flex',
                  'iv-justify-center iv-items-center',
                  'iv-w-[28px] iv-h-[28px]',
                  'iv-rounded-full',
                  'iv-bg-black-70',
                )}
              >
                <ImageComponent
                  elementype="native"
                  loading="lazy"
                  alt="close icon"
                  src={getAssetUrl('blog', '/icons/white-cross.svg')}
                  width="15"
                  height="15"
                />
              </button>
            </div>
            <div
              className={ivclass(
                'iv-absolute',
                'iv-h-[286px] iv-w-[506px]',
                'sm:iv-w-[310px] sm:iv-h-[175px]',
                'iv-bottom-[0] iv-right-[0]',
                'iv-overflow-hidden',
                'iv-rounded-br-[20px]',
              )}
            >
              <ImageComponent
                elementype={'native'}
                loading={'lazy'}
                src={getAssetUrl('blog', bgImagePath)}
                className={ivclass('iv-w-full', 'iv-object-fill')}
              />
            </div>
            <div
              className={ivclass(
                'iv-text-heading-m iv-font-bold',
                'sm:iv-text-heading-2xs',
                'iv-text-grey-0 ',
                'iv-h-full',
                'iv-flex iv-justify-between iv-flex-col',
              )}
            >
              <div className={ivclass('iv-max-w-[550px]')}>
                Wait, you’re one step away from creating{' '}
                <span className={ivclass('iv-text-white-50')}>
                  thumb-stopping videos!
                </span>
              </div>
              <button
                className={ivclass(
                  'iv-text-body-2xl sm:iv-text-body-xl iv-font-semibold',
                  'iv-bg-grey-0 ',
                  'iv-px-[10px] ',
                  'iv-py-[12px] lg:iv-py-[12px] ',
                  'iv-text-deep-blue',
                  'iv-rounded-[110px]',
                  'iv-max-w-[230px] lg:iv-max-w-[230px] md:iv-max-w-[240px] sm:iv-max-w-[200px]',
                  'iv-z-50',
                  'focus:iv-outline-none',
                  'iv-whitespace-nowrap',
                )}
                onClick={handleClick}
              >
                Get started — it’s free!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitIntentModal;
